import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import {
  Button,
  message,
  Modal,
  Table,
  Popconfirm,
  Form,
  Select,
  Input,
  InputNumber,
  Upload,
} from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { stationApi } from "@api/newApi";
import { Graph, Shape } from "@antv/x6";
import { Transform } from "@antv/x6-plugin-transform";
import { toolMouseTip } from "@utils/common";
import StationProcess from "../../../../../components/StationProcess";

const { UPLOADER } = window.globalConfig;

Shape.HTML.register({
  shape: "custom-html",
  width: 80,
  height: 30,
  effect: ["data"],
  html(cell) {
    const { type, attrName, value, unit, isShowName } = cell.getData();
    const div = document.createElement("div");
    div.className = "custom-html";
    const customHead =
      isShowName == 1 ? `<div class="h">${attrName}</div>` : "";
    if (type == 1) {
      div.innerHTML = `
        ${customHead}
        <div class="${value == 1 ? "v success" : "v error"}">
          ${value == 1 ? "启动" : "停止"}
        </div>
      `;
    } else {
      div.innerHTML = `
        ${customHead}
        <div class="v" style="transform: scale(0.9)">${value}${unit}</div>
      `;
    }
    return div;
  },
});

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
const Pages = ({ nextStep, selStationInfo = {} }) => {
  const [form] = Form.useForm();
  const [chainList, setChainList] = useState([]); // 左侧工艺点
  const [checkedIds, setCheckedIds] = useState([]); // 画布选中的id
  const [bgImgStyle, setBgImgStyle] = useState({
    // 背景图样式
    width: 1540,
    height: 680,
  });
  // 是否展示预览弹窗
  const [isShowPreviewModal, setIsShowPreviewModal] = useState(false);
  const [graphObj, setGraphObj] = useState();
  const [processPointAttrs, setProcessPointAttrs] = useState([]);
  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [attrType, setAttrType] = useState(2);
  const [processunitId, setProcessunitId] = useState();
  const [processAttrId, setProcessAttrId] = useState();
  const [previewProcessData, setPreviewProcessData] = useState({});
  const [loading1, setLoading1] = useState(false);
  const [warnSetId, setWarnSetId] = useState();
  const [importDeviceList, setImportDeviceList] = useState([]);
  const [imgLoading, setImgLoading] = useState(false);
  const [canvasBg, setCanvasBg] = useState("");

  const columns = [
    {
      title: "属性名称",
      dataIndex: "attrName",
      align: "center",
      key: "attrName",
      width: 120,
      render: (_t) => toolMouseTip(_t, 20),
    },
    {
      title: "属性编码",
      dataIndex: "attrCode",
      align: "center",
      key: "attrCode",
      width: 120,
      render: (_t) => toolMouseTip(_t, 20),
    },
    {
      title: "属性值",
      dataIndex: "value",
      align: "center",
      key: "value",
      width: 120,
      render: (_t) => toolMouseTip(_t, 20),
    },
    {
      title: "单位",
      dataIndex: "unit",
      align: "center",
      key: "unit",
      width: 80,
      render: (_t) => toolMouseTip(_t, 20),
    },
    {
      title: "重要显示",
      dataIndex: "isMainShow",
      align: "center",
      key: "isMainShow",
      width: 100,
      render: (_t) => (_t == 1 ? "是" : "否"),
    },
    {
      title: "显示名称",
      dataIndex: "isShowName",
      align: "center",
      key: "isShowName",
      width: 100,
      render: (_t) => (_t == 1 ? "是" : "否"),
    },
    {
      title: "操作",
      dataIndex: "operation",
      width: 160,
      align: "center",
      render: (_, record) =>
        processPointAttrs.length >= 1 ? (
          <>
            <Popconfirm
              title="请确定要删除吗?"
              onConfirm={() => handleDelete(record.id)}
            >
              <a>删除</a>
            </Popconfirm>
            <a style={{ padding: "0 10px" }} onClick={() => editAttr(record)}>
              编辑
            </a>
            <a onClick={() => warnSet(record)}>告警设置</a>
          </>
        ) : null,
    },
  ];

  useEffect(() => {
    setTimeout(() => {
      const graph = new Graph({
        container: document.getElementById("topologyCanvas"),
        width: bgImgStyle.width,
        height: bgImgStyle.height,
        connecting: {
          snap: true,
          allowBlank: false,
          allowLoop: false,
          allowNode: false,
          highlight: true,
          createEdge: () => {
            const edge = graph.createEdge({
              attrs: {
                line: {
                  strokeWidth: 3,
                  stroke: "#fff",
                  strokeDasharray: 2,
                  sourceMarker: "cross",
                  targetMarker: "cross",
                  style: {
                    animation: "ant-line 30s infinite linear",
                  },
                },
              },
            });
            return edge;
          },
        },
        // grid: {
        //   visible: true,
        // },
      });

      graph.use(
        new Transform({
          resizing: {
            enabled: true,
            grid: 15,
            minWidth: 1,
            minHeight: 1,
            orthogonal: false,
            restrict: false,
            preserveAspectRatio: false,
          },
          // rotating: {
          //   enabled: true,
          //   grid: 15
          // }
        })
      );

      customNode();

      // 工艺节点删除
      graph.on("node:delete", ({ view, e }) => {
        const { options } = view.cell.store.data;
        e.stopPropagation();
        view.cell.remove();
        setCheckedIds((prevIds) =>
          prevIds.filter((item) => item !== options.processunitId)
        );
      });

      // 监听 button-remove 的点击事件
      graph.on("node:removed", ({ node }) => {
        const { data, shape } = node.store.data;
        if (shape == "custom-html") {
          setImportDeviceList((prevIds) =>
            prevIds.filter((item) => item.id !== data.id)
          );
        }
      });

      // 点击展开详情
      graph.on("node:click", ({ view, e }) => {
        const { options } = view.cell.store.data;
        e.stopPropagation();
        if (e.target.tagName == "rect" || e.target.tagName == "tspan") {
          setVisible(true);
          setProcessunitId(options.processunitId);
        }
      });

      graph.on("edge:mouseenter", ({ cell }) => {
        cell.addTools([
          {
            name: "source-arrowhead",
          },
          {
            name: "target-arrowhead",
            args: {
              attrs: {
                fill: "red",
              },
            },
          },
          {
            name: "button-remove",
            args: { distance: 20 },
          },
        ]);
      });

      graph.on("edge:mouseleave", ({ cell }) => {
        cell.removeTools([
          {
            name: "source-arrowhead",
          },
          {
            name: "target-arrowhead",
            args: {
              attrs: {
                fill: "red",
              },
            },
          },
          {
            name: "button-remove",
            args: { distance: 20 },
          },
        ]);
      });
      setGraphObj(graph);
      getProcessList();
      findFlowByStationId(graph);
    }, 0);

    return () => {
      graphObj && graphObj.destroy();
      setGraphObj(null);
    };
  }, []);

  useEffect(() => {
    if (processunitId) {
      const crt = chainList.find((item) => item.processunitId == processunitId);
      if (crt) {
        crt.diyAttrList &&
          crt.diyAttrList.map((item, index) => {
            item.key = index + 1;
          });
        setProcessPointAttrs(crt.diyAttrList);
      }
    }
  }, [chainList, processunitId]);

  const findFlowByStationId = (graph) => {
    stationApi.findFlowByStationId(selStationInfo.id).then((res) => {
      if (res.status !== "0") return;
      const ids = [];
      let edges = [];
      const nodeList = [];
      const {
        processFlowUnitDTOList,
        canvasWidth,
        canvasHeight,
        processFlowDeviceDiyDTOList,
      } = res.data;
      setCanvasBg(res.data.canvasBg);
      setImportDeviceList(processFlowDeviceDiyDTOList);
      if (canvasWidth && canvasHeight) {
        setBgImgStyle({ width: canvasWidth, height: canvasHeight });
        graph.resize(canvasWidth, canvasHeight);
      }
      processFlowUnitDTOList &&
        processFlowUnitDTOList.map((item) => {
          const { processunitId } = item;
          ids.push(processunitId);
          const nodes = generateNode(item, item.unitPic);
          const n = graph.addNode(nodes);
          if (item.linePath && item.linePath.length > 0) {
            edges = [...edges, ...item.linePath];
          }
          nodeList.push(n);
        });
      setCheckedIds(ids);

      edges.forEach((item) => {
        const { startX, startY, endX, endY } = item;
        const source = nodeList.find((subItem) => {
          const { posX, posY, width, height } = subItem.store.data.options;
          return (
            Math.ceil(width / 2 + posX) == Math.ceil(startX) &&
            Math.ceil(height / 2 + posY) == Math.ceil(startY)
          );
        });
        const target = nodeList.find((subItem) => {
          const { posX, posY, width, height } = subItem.store.data.options;
          return (
            Math.ceil(width / 2 + posX) == Math.ceil(endX) &&
            Math.ceil(height / 2 + posY) == Math.ceil(endY)
          );
        });
        graph.addEdge({
          source: { cell: source, port: "port1" }, // 源节点
          target: { cell: target, port: "port1" }, // 目标节点
          attrs: {
            line: {
              strokeWidth: 3,
              stroke: "#fff",
              strokeDasharray: 2,
              sourceMarker: "cross",
              targetMarker: "cross",
              style: {
                animation: "ant-line 30s infinite linear",
              },
            },
          },
        });
      });
      processFlowDeviceDiyDTOList.forEach((item) => {
        const { posX, posY, width, height } = item;
        graph.addNode({
          shape: "custom-html",
          x: posX,
          y: posY,
          width,
          height,
          data: item,
          tools: ["button-remove"],
        });
      });
    });
  };

  // 上一步按钮
  const prevBtn = () => {
    nextStep(0);
  };

  // 预览按钮
  const previewBtn = () => {
    const params = handleData();
    setPreviewProcessData(params);
    setIsShowPreviewModal(true);
  };

  const handleData = () => {
    const datas = graphObj.toJSON().cells;
    const customNode = [];
    const processFlowDeviceDiyDTOList = [];
    datas &&
      datas.forEach((item) => {
        if (item.shape == "custom-node") {
          // const node = graphObj.getCellById(item.id);
          // const angle = node.getAngle();
          customNode.push({
            posX: item.position.x,
            posY: item.position.y,
            width: item.size.width,
            height: item.size.height,
            processunitId: item.options.processunitId,
            processunitName: item.options.processunitName,
            id: item.id,
            linePath: [],
            unitPic: item.options.unitPic,
            // angle
          });
        } else if (item.shape == "edge") {
          const edge = graphObj.getCellById(item.id);
          const sourcePoint = edge.getSourcePoint();
          const targetPoint = edge.getTargetPoint();
          const idx = customNode.findIndex((s) => s.id == item.source.cell);
          if (idx > -1) {
            customNode[idx].linePath.push({
              startX: sourcePoint.x,
              startY: sourcePoint.y,
              endX: targetPoint.x,
              endY: targetPoint.y,
            });
          }
        } else if (item.shape == "custom-html") {
          processFlowDeviceDiyDTOList.push({
            ...item.data,
            posX: item.position.x,
            posY: item.position.y,
            width: item.size.width,
            height: item.size.height,
            processunitId: item.data.processunitId,
            deviceDiyId: item.data.id,
          });
        }
      });
    const params = {
      stationId: selStationInfo.id,
      name: `${selStationInfo.name}-工艺流程`,
      canvasWidth: bgImgStyle.width,
      canvasHeight: bgImgStyle.height,
      processFlowUnitDTOList: customNode,
      processFlowDeviceDiyDTOList,
      canvasBg,
    };
    return params;
  };

  // 完成按钮
  const saveBtn = () => {
    const data = handleData();
    setLoading1(true);
    stationApi
      .updateProcessFlow(data)
      .then((res) => {
        setLoading1(false);
        if (res.status !== "0") return;
        message.success("保存成功");
      })
      .catch(() => {
        setLoading1(false);
      });
  };

  const handleDelete = (id) => {
    stationApi.deleteUnitAttrById(id).then((res) => {
      if (res.status !== "0") return;
      message.success("删除成功");
      getProcessList();
    });
  };

  // 获取工艺单元详情
  const getProcessList = () => {
    setLoading(true);
    stationApi.findProcessByStationId(selStationInfo.id).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      setChainList(res.data);
    });
  };

  const onDragStartFn = (event, node) => {
    event.dataTransfer.dropEffect = "move";
    event.dataTransfer.setData("text/plain", JSON.stringify(node)); // 设置拖拽数据
  };

  const onDragOverFn = (event) => {
    event.preventDefault(); // 确保浏览器允许拖拽
    event.dataTransfer.dropEffect = "move"; // 设置具体的拖拽效果
  };

  const onDragEndFn = (event, data) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    if (checkedIds.includes(data.processunitId)) {
      message.error("工艺单元已存在");
      return;
    }
    const topologyCanvas = document.getElementById("topologyCanvas");
    const offsetLeft = topologyCanvas.getBoundingClientRect().left;
    const offsetTop = topologyCanvas.getBoundingClientRect().top;
    let x = event.clientX - offsetLeft;
    let y = event.clientY - offsetTop;
    const { processunitId, unitPic } = data;
    if (data.hide) return;
    if (!unitPic) return message.error("当前设备图片不存在");
    const img = new Image();
    img.src = unitPic;
    img.onload = () => {
      const { width, height } = img;
      if (x < 0 || y < 0) return message.error("请拖拽到画布上");
      const params = {
        ...data,
        posX: x,
        posY: y,
        width,
        height,
      };
      const nodeOptions = generateNode(params, unitPic);
      graphObj.addNode(nodeOptions);
      setCheckedIds(() => {
        return [...checkedIds, processunitId];
      });
    };
    // 处理加载错误
    img.onerror = () => {
      message.error("图片加载失败");
    };
  };

  const generateNode = (data, imageUrl) => {
    const { posX, posY, width, height, processunitName } = data;

    // 创建一个临时的 SVG 元素来测量文本尺寸
    const measureText = (text, fontSize = 12) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      ctx.font = `${fontSize}px sans-serif`;
      const metrics = ctx.measureText(text);
      return {
        width: Math.ceil(metrics.width) + 10, // 增加一些内边距
        height: fontSize + 5,
      };
    };

    const textSize = measureText(processunitName);

    const nodes = {
      shape: "custom-node",
      x: posX,
      y: posY,
      width,
      height,
      imageUrl,
      options: data,
      attrs: {
        label: {
          text: processunitName,
          fill: "#fff",
          fontSize: 12,
          fontWeight: "bold",
          textAnchor: "middle",
          refX: "50%",
          refY: "100%",
          cursor: "pointer",
          event: "node:click",
        },
        body: {
          stroke: "#1A2A4B",
          strokeWidth: 1,
          fill: "#1A2A4B",
          width: textSize.width,
          height: textSize.height,
          refX: "50%",
          refY: "100%",
          rx: 5,
          ry: 5,
          x: -textSize.width / 2,
          y: -textSize.height / 2,
          cursor: "pointer",
          event: "node:click",
        },
        img: {
          "xlink:href": imageUrl,
          width,
          height,
        },
      },
      ports: {
        groups: {
          in: {
            position: { name: "absolute" },
            attrs: {
              circle: {
                magnet: true,
                stroke: "#8f8f8f",
                r: 5,
              },
            },
          },
        },
        items: [
          {
            id: "port1",
            group: "in",
            args: {
              x: "50%",
              y: "50%",
            },
          },
        ],
      },
    };

    return nodes;
  };

  const onCancel = () => {
    setVisible(false);
    const mainShowList = processPointAttrs.filter(
      (item) => item.isMainShow == 1
    );
    const arr = [...importDeviceList];
    const nodes = graphObj
      .toJSON()
      .cells.filter((item) => item.shape == "custom-node");
    mainShowList.forEach((item) => {
      const processUnit = nodes.find(
        (subItem) => subItem.options.processunitId == item.processunitId
      );
      const imIdx = arr.findIndex((subItem) => subItem.id == item.id);
      if (processUnit) {
        if (imIdx == -1) {
          const { x, y } = processUnit.position;
          graphObj.addNode({
            shape: "custom-html",
            x,
            y,
            data: item,
            tools: ["button-remove"],
          });
          arr.push({
            ...item,
            posX: x,
            posY: y,
            width: 100,
            height: 42,
          });
        } else {
          const data = {
            ...arr[imIdx],
            ...item,
          };
          arr[imIdx] = data;

          // 获取所有 custom-html 类型的节点
          const customHtmlNodes = graphObj
            .getNodes()
            .filter((node) => node.shape === "custom-html");
          const targetNode = customHtmlNodes.find(
            (node) => node.getData()?.id === item.id
          );
          if (targetNode) {
            targetNode.setData(data);
          }
        }
      }
    });
    setImportDeviceList(() => [...arr]);
  };

  const addAttr = () => {
    setVisible1(true);
    setTitle("新增属性");
    setAttrType(2);
    form.setFieldsValue({
      enumMapList: [{ key: "", value: "" }],
    });
  };

  const editAttr = (record) => {
    setVisible1(true);
    setTitle("修改属性");
    const {
      type,
      attrName,
      attrCode,
      enumMap,
      id,
      unit,
      isMainShow,
      isShowName,
    } = record;
    setAttrType(type);
    setProcessAttrId(id);
    const params = { type, attrName, attrCode, unit, isMainShow, isShowName };
    const enumMapList = [];
    if (type == 3) {
      enumMap.split(",").map((item, index) => {
        if (index % 2 == 0 && item) {
          enumMapList.push({
            key: item,
            value: enumMap.split(",")[index + 1],
          });
        }
      });
      params.enumMapList = enumMapList;
    }
    form.setFieldsValue({ ...params });
  };

  const saveAttr = () => {
    form.validateFields().then((values) => {
      const params = {
        ...values,
        stationId: selStationInfo.id,
        processunitId,
      };
      if (values.type == 3) {
        let enumMap = "";
        values.enumMapList.map((item) => {
          if (item.key && item.value) {
            enumMap += item.key + "," + item.value + ",";
          }
        });
        enumMap = enumMap.substring(0, enumMap.lastIndexOf(","));
        params.enumMap = enumMap;
        delete params.enumMapList;
      }
      if (processAttrId) {
        setConfirmLoading(true);
        stationApi
          .updateProcessUnitAttr({ ...params, id: processAttrId })
          .then((res) => {
            setConfirmLoading(false);
            if (res.status !== "0") return;
            message.success("修改成功");
            cancelAttr();
            getProcessList();
          });
      } else {
        setConfirmLoading(true);
        stationApi.addProcessUnitAttr(params).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("新增成功");
          cancelAttr();
          getProcessList();
        });
      }
    });
  };

  const cancelAttr = () => {
    setVisible1(false);
    setTitle("");
    setAttrType(2);
    setProcessAttrId(null);
    form.resetFields();
  };

  const warnSet = (record) => {
    setWarnSetId(record.id);
    stationApi.findDeviceAlarmSetByAttrId(record.id).then((res) => {
      if (res.data) {
        form.setFieldsValue({
          ...res.data,
        });
      } else {
        form.setFieldsValue({
          alarmKey: record.attrCode,
        });
      }
      setVisible2(true);
    });
  };

  const cancelWarnSet = () => {
    setVisible2(false);
    form.resetFields();
    setWarnSetId();
  };

  const saveWarnSet = () => {
    form.validateFields().then((values) => {
      const params = { ...values, diyAttrId: warnSetId };
      setConfirmLoading(true);
      stationApi.updateDeviceAlarmSet(params).then((res) => {
        setConfirmLoading(false);
        if (res.status !== "0") return;
        message.success("修改成功！");
        cancelWarnSet();
      });
    });
  };

  const customNode = () => {
    Graph.registerNode(
      "custom-node",
      {
        inherit: "image",
        width: 100,
        height: 40,
        markup: [
          {
            tagName: "image",
            selector: "img",
          },
          {
            tagName: "rect", // 标签名称
            selector: "body", // 选择器
          },
          {
            tagName: "g",
            children: [
              {
                tagName: "rect",
                selector: "btn",
              },
              {
                tagName: "text",
                selector: "btnText",
              },
            ],
          },
          {
            tagName: "text",
            selector: "label",
          },
        ],
        attrs: {
          btn: {
            refX: "50%",
            refY: "100%",
            x: -51,
            y: -21,
            width: 12,
            height: 12,
            rx: 10,
            ry: 10,
            fill: "#FF0000",
            stroke: "red",
            cursor: "pointer",
          },
          btnText: {
            fontSize: 14,
            fill: "#fff",
            text: "x",
            refX: "50%",
            refY: "100%",
            x: -45,
            y: -15,
            cursor: "pointer",
            event: "node:delete",
          },
        },
      },
      true
    );
  };

  // 背景图样式改变事件
  const changeImgStyle = (e, type) => {
    let obj = { ...bgImgStyle };
    obj[type] = e.target.value * 1;
    setBgImgStyle({
      ...obj,
    });
  };

  // 修改背景底图样式
  const bgImgStyleSure = () => {
    graphObj.resize(bgImgStyle.width, bgImgStyle.height);
  };

  const uploadProps = {
    accept: "image/png",
    action: UPLOADER,
    listType: "picture",
    showUploadList: false,
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("你只能上传jpg或png图片格式");
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error("图片必需小于5M");
      }
      return isJpgOrPng && isLt5M;
    },
    onChange: (info) => {
      if (info.file.status === "uploading") {
        setImgLoading(true);
      }
      if (info.file.status === "done") {
        const res = info.file.response;
        setImgLoading(false);
        if (res.status == "0") {
          setCanvasBg(res.data.url);
        }
      }
    },
  };

  const gotoUnitProcess = (obj) => {
    window.open(
      `/#/stationManagement/processUnitProcessFlow?id=${obj.processunitId}`
    );
  };

  return (
    <div className="step2-box step-box" id="processSet-step2-box">
      <div className="top-box">
        <div>
          <Upload {...uploadProps}>
            <Button type="default" loading={imgLoading}>
              设置厂站背景底图
            </Button>
          </Upload>
          <span style={{ marginLeft: "20px" }}>{selStationInfo.name}</span>
        </div>
        <div className="btn-area">
          <Button type="primary" onClick={prevBtn}>
            上一步
          </Button>
          <Button type="primary" onClick={previewBtn}>
            预览
          </Button>
          <Button loading={loading1} type="primary" onClick={saveBtn}>
            完成
          </Button>
        </div>
      </div>
      <div className="con-box">
        <div className="process-area">
          <div className="tit">工艺环节({chainList.length})</div>
          <div className="process-box">
            {chainList.length == 0 && (
              <div className="no-data">该厂站暂无工艺单元</div>
            )}
            {chainList.map((item, index) => (
              <div
                className={classnames({
                  item: true,
                  disabledExist: checkedIds.includes(item.processunitId),
                })}
                onDragStart={(e) => onDragStartFn(e, item)}
                onDragOver={(e) => onDragOverFn(e)}
                onDragEnd={(e) => onDragEndFn(e, item)}
                title={item.processunitName}
                draggable={!checkedIds.includes(item.processunitId)}
                key={"chain" + index}
              >
                <div className="header">{item.processunitName}</div>
                <SettingOutlined onClick={() => gotoUnitProcess(item)} />
              </div>
            ))}
          </div>
        </div>
        <div className="canvas-box">
          {
            <div className="ipt-box">
              背景图样式设置： 宽：
              <input
                value={bgImgStyle.width}
                onChange={(e) => changeImgStyle(e, "width")}
                type="number"
              />
              高：
              <input
                value={bgImgStyle.height}
                onChange={(e) => changeImgStyle(e, "height")}
                type="number"
              />
              <Button size="small" onClick={bgImgStyleSure}>
                确 定
              </Button>
            </div>
          }
          <div
            onDragOver={(e) => e.preventDefault()}
            id="topologyCanvas"
            style={{ backgroundImage: `url(${canvasBg})` }}
          ></div>
        </div>
      </div>

      {/* 预览弹窗 begin */}
      {isShowPreviewModal && (
        <Modal
          title="预览"
          open={isShowPreviewModal}
          width={bgImgStyle.width}
          getContainer={() => document.getElementById("processSet-step2-box")}
          onCancel={() => {
            setIsShowPreviewModal(false);
            setPreviewProcessData({});
          }}
          footer={false}
        >
          <div
            style={{
              height: bgImgStyle.height,
              background: "#101621",
              position: "relative",
            }}
          >
            <StationProcess
              previewProcessData={previewProcessData}
              dataShow={false}
            />
          </div>
        </Modal>
      )}
      {/* 预览弹窗 end */}

      <Modal
        title="属性操作"
        open={visible}
        onCancel={onCancel}
        footer={false}
        width={900}
      >
        <Button type="primary" onClick={addAttr}>
          新增
        </Button>
        <Table
          loading={loading}
          bordered
          dataSource={processPointAttrs}
          columns={columns}
          pagination={false}
        />
      </Modal>

      {visible1 && (
        <Modal
          title={title}
          open={visible1}
          onCancel={cancelAttr}
          onOk={saveAttr}
          width={800}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.Item
              label="属性名称"
              name="attrName"
              rules={[{ required: true, message: "请输入属性名称" }]}
            >
              <Input placeholder={"请输入属性名称"} />
            </Form.Item>
            <Form.Item
              label="属性编码"
              name="attrCode"
              rules={[{ required: true, message: "请输入属性编码" }]}
            >
              <Input placeholder={"请输入属性编码"} />
            </Form.Item>
            <Form.Item
              label="单位"
              name="unit"
              rules={[{ required: false, message: "请输入单位" }]}
            >
              <Input placeholder={"请输入单位"} />
            </Form.Item>
            <Form.Item
              label="重要显示"
              name="isMainShow"
              rules={[{ required: true, message: "请选择重要显示" }]}
            >
              <Select placeholder="请选择重要显示">
                <Select.Option value={0}>否</Select.Option>
                <Select.Option value={1}>是</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="显示名称"
              name="isShowName"
              rules={[{ required: true, message: "请选择是否显示名称" }]}
            >
              <Select placeholder="请选择是否显示名称">
                <Select.Option value={0}>否</Select.Option>
                <Select.Option value={1}>是</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="属性类型"
              name="type"
              rules={[{ required: true, message: "请选择属性类型" }]}
            >
              <Select
                placeholder="请选择属性类型"
                onChange={(e) => setAttrType(e)}
              >
                <Select.Option value={1}>布尔类型</Select.Option>
                <Select.Option value={2}>字符串</Select.Option>
                <Select.Option value={3}>枚举</Select.Option>
              </Select>
            </Form.Item>
            {attrType == 3 && (
              <Form.Item label="枚举列表">
                <Form.List name="enumMapList" label="枚举列表">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map((field) => (
                        <div key={field.key}>
                          <Form.Item
                            label="枚举Key"
                            name={[field.name, "key"]}
                            rules={[
                              { required: true, message: "请填写枚举Key!" },
                            ]}
                          >
                            <Input placeholder={"请填写枚举Key"} />
                          </Form.Item>
                          <Form.Item
                            label="枚举Value"
                            name={[field.name, "value"]}
                            rules={[
                              { required: true, message: "请填写枚举Value!" },
                            ]}
                          >
                            <Input placeholder={"请填写枚举Value"} />
                          </Form.Item>
                          <Form.Item>
                            {fields.length > 1 && (
                              <Button
                                type="dashed"
                                onClick={() => remove(field.name)}
                              >
                                移除
                              </Button>
                            )}
                          </Form.Item>
                        </div>
                      ))}
                      <Form.Item>
                        <Button type="dashed" onClick={() => add()}>
                          添加
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Form.Item>
            )}
          </Form>
        </Modal>
      )}

      {visible2 && (
        <Modal
          title="告警设置"
          open={visible2}
          onCancel={cancelWarnSet}
          onOk={saveWarnSet}
          width={800}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.Item
              label="告警Key"
              name="alarmKey"
              rules={[{ required: true, message: "请输入告警Key" }]}
            >
              <Input placeholder={"请输入告警Key"} disabled />
            </Form.Item>
            <Form.Item
              label="告警名称"
              name="name"
              rules={[{ required: true, message: "请输入告警名称" }]}
            >
              <Input placeholder={"请输入告警名称"} />
            </Form.Item>
            <Form.Item
              label="告警值"
              name="alarmValue"
              rules={[{ required: true, message: "请输入告警值" }]}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder={"请输入告警值"}
              />
            </Form.Item>
            <Form.Item
              label="告警运算符"
              name="alarmRelateType"
              rules={[{ required: true, message: "请选择告警运算符" }]}
            >
              <Select placeholder="请选择告警运算符">
                <Select.Option value={0}>等于</Select.Option>
                <Select.Option value={1}>大于</Select.Option>
                <Select.Option value={2}>大于等于</Select.Option>
                <Select.Option value={3}>小于</Select.Option>
                <Select.Option value={4}>小于等于</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="状态"
              name="status"
              rules={[{ required: true, message: "请选择状态" }]}
            >
              <Select placeholder="请选择状态">
                <Select.Option value={0}>未开启</Select.Option>
                <Select.Option value={1}>开启</Select.Option>
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
